import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SortMenuItem } from '@/types';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentExtensionReportSort',
  props: {
    modelValue: {
        type: Array<SortMenuItem>,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const sortMenuItems = ref([
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.name'),
        key: 'name',
    },
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.extension'),
        key: 'extension',
    },
] as SortMenuItem[]);

const props = __props;

const emit = __emit;

const updateValue = (value: SortMenuItem[]) => {
    emit('update:modelValue', value.slice(-1));
};

return (_ctx: any,_cache: any) => {
  const _component_UiSortMenu = _resolveComponent("UiSortMenu")!

  return (_openBlock(), _createBlock(_component_UiSortMenu, {
    items: sortMenuItems.value,
    "model-value": props.modelValue,
    fixmobile: "",
    "onUpdate:modelValue": updateValue
  }, null, 8, ["items", "model-value"]))
}
}

})